import type { SpriNavigationItem } from '@spri/components/navigation';

import { patientsBasicNavigationItem, positConnectBasicNavigationItem } from './navigation-shared-basic-items';

export const clinicianNavigation: SpriNavigationItem[] = [
  // Clinical Data
  {
    id: 'clinical-data',
    title: 'Clinical Data',
    type: 'collapsable',
    icon: 'clinical-data',
    children: [
      {
        id: 'surgery-forms',
        title: 'Surgery Forms',
        type: 'basic',
        link: '/clinical-data/surgery-form',
      },
      {
        id: 'exam-forms',
        title: 'Exam Forms',
        type: 'basic',
        link: '/clinical-data/exam-form',
      },
    ],
  },
  // Patient Surveys
  {
    id: 'patient-surveys',
    title: 'Patient Surveys',
    type: 'collapsable',
    icon: 'patient-survey',
    children: [
      {
        id: 'manual',
        title: 'Manual',
        type: 'basic',
        link: '/patient-surveys/manual',
      },
    ],
  },
  patientsBasicNavigationItem,
  positConnectBasicNavigationItem,
];

// Export the same navigation for different layout types
export const compactNavigation = clinicianNavigation;
export const futuristicNavigation = clinicianNavigation;
export const horizontalNavigation = clinicianNavigation;
